import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-up",
  "use": "icon-icon-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-icon-up\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.436 15.435a1 1 0 0 1-1.415 0l-5.656-5.657-5.657 5.657a1 1 0 1 1-1.415-1.415l6.364-6.364a1 1 0 0 1 1.415 0l6.364 6.364a1 1 0 0 1 0 1.415Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol